import { useLang } from "@/i18n/LanguageContext";

export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="lang-toggle"
      className={`flex items-center gap-1 font-mono-tech text-xs tracking-[0.2em] ${className}`}
    >
      {["fr", "en"].map((l, i) => (
        <span key={l} className="flex items-center">
          {i === 1 && <span className="text-[#4a4a4a] mx-1">/</span>}
          <button
            data-testid={`lang-${l}`}
            onClick={() => setLang(l)}
            className={`px-1 py-0.5 uppercase transition-colors duration-300 ${
              lang === l ? "text-[#75FB4E]" : "text-[#808080] hover:text-[#E5E5E5]"
            }`}
          >
            {l}
          </button>
        </span>
      ))}
    </div>
  );
}
